import React from 'react';
import { Skeleton } from '@mui/material';
import { Box } from '@eatclubapp/ec-component-library';

const PageSkeleton = () => {
  return (
    <Box
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#F1F3F1',
        zIndex: 49,
      }}
    >
      {/* AppBar - 65px */}
      <Box
        style={{
          height: 65,
          backgroundColor: '#F1F3F1',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          gap: 8,
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center', gap: 2, flexBasis: '33%' }}>
          <Skeleton variant='circular' width={40} height={40} />
          <Skeleton variant='rectangular' width={110} height={40} style={{ borderRadius: 100 }} />
        </Box>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            justifyContent: 'center',
            flex: 1,
          }}
        >
          <Skeleton variant='rectangular' width={220} height={38} style={{ borderRadius: 100 }} />
          <Skeleton variant='rectangular' width={160} height={38} style={{ borderRadius: 100 }} />
        </Box>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexBasis: '33%',
            justifyContent: 'flex-end',
          }}
        >
          <Skeleton variant='circular' width={40} height={40} />
          <Skeleton variant='circular' width={40} height={40} />
          <Skeleton variant='rectangular' width={130} height={40} style={{ borderRadius: 20 }} />
        </Box>
      </Box>

      {/* Tabs + filter bar */}
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 36px 16px',
        }}
      >
        <Box style={{ display: 'flex', gap: 24, alignItems: 'baseline' }}>
          <Skeleton variant='rectangular' width={120} height={36} style={{ borderRadius: 4 }} />
          <Skeleton variant='rectangular' width={120} height={36} style={{ borderRadius: 4 }} />
        </Box>
        <Box style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Skeleton variant='rectangular' width={200} height={36} style={{ borderRadius: 8 }} />
          <Skeleton variant='rectangular' width={130} height={36} style={{ borderRadius: 8 }} />
          <Skeleton variant='rectangular' width={80} height={36} style={{ borderRadius: 8 }} />
          <Skeleton variant='rectangular' width={70} height={36} style={{ borderRadius: 8 }} />
        </Box>
      </Box>

      {/* Content area */}
      <Box
        style={{
          padding: '0 16px 20px',
          height: 'calc(100vh - 65px)',
          boxSizing: 'border-box',
        }}
      >
        <Box
          style={{
            backgroundColor: '#fff',
            borderRadius: 24,
            boxShadow: '0px 4px 4px 1px rgba(0,0,0,0.06)',
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Column headers - 48px */}
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 48,
              padding: '0 16px',
              flexShrink: 0,
            }}
          >
            <Box style={{ width: 60, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={45} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 100, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={50} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 70, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={45} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 60, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={40} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 100, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={40} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 100, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={45} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 80, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={30} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ flex: 1 }}>
              <Skeleton variant='rectangular' width={140} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 90, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={75} height={20} style={{ borderRadius: 4 }} />
            </Box>
            <Box style={{ width: 100, flexShrink: 0 }}>
              <Skeleton variant='rectangular' width={55} height={20} style={{ borderRadius: 4 }} />
            </Box>
          </Box>

          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
          <Skeleton
            variant='rectangular'
            height={45}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: 50,
              padding: '0 16px',
              borderBottom: '1px solid #f0f0f0',
              flexShrink: 0,
              marginBottom: '10px',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PageSkeleton;
